/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { CssBaseline } from '@material-ui/core'
import { withStyles, ThemeProvider, createTheme } from '@material-ui/core/styles'
import { SnackbarProvider } from 'notistack'
import React, { Suspense, lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

import Header from './components/Header'
import ScrollToTop from './components/ScrollToTop'
import Loading from './components/Loading'

const Homepage = lazy(() => import('./pages/Homepage'))
const OurClient = lazy(() => import('./pages/OurClient/OurClient'))
const PortfolioPage = lazy(() => import('./pages/Portfolio'))
const ProjectDetailPage = lazy(() => import('./pages/ProjectDetails'))
const ServicePage = lazy(() => import('./pages/Services/Services'))
const Industries = lazy(() => import('./pages/Industries'))
const IndustryDetail = lazy(() => import('./pages/Industries/IndustryDetail'))
const MembersList = lazy(() => import('./pages/Member'))
const MemberDetail = lazy(() => import('./pages/Member/MemberDetail'))
const NotFound = lazy(() => import('./pages/NotFound'))
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy/PrivacyPolicy'))

const styles = {
  success: { backgroundColor: '#2DAA67' },
  error: { backgroundColor: '#F50057' },
  app: {
    backgroundColor: '#000000',
    minHeight: '100vh'
  }
}

const theme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#2DAA67'
    },
    secondary: {
      main: '#F50057'
    },
    background: {
      default: '#000000',
      paper: '#121212'
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          WebkitFontSmoothing: 'auto',
          scrollbarGutter: 'stable',
          overflowY: 'scroll'
        },
        body: {
          backgroundColor: '#000000',
          overflowX: 'hidden'
        }
      }
    }
  }
})

function App({ classes }) {
  return (
    <div className={classes.app}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          preventDuplicate
          classes={{
            variantSuccess: classes.success,
            variantError: classes.error
          }}
        >
          <CssBaseline />
          <Header />

          <ScrollToTop />
          <Suspense fallback={<Loading />}>
            <Switch>
              <Route path="/" exact component={Homepage} />
              <Route path="/services" component={ServicePage} />
              <Route path="/portfolio" exact component={PortfolioPage} />
              <Route exact path="/industries" component={Industries} />
              <Route path="/industries/:slug" component={IndustryDetail} />
              <Route exact path="/members" component={MembersList} />
              <Route exact path="/members/:name" component={MemberDetail} />
              <Route path="/portfolio/:projectSlug" component={ProjectDetailPage} />
              <Route path="/privacy" component={PrivacyPolicy} />
              <Route path="/our-client" component={OurClient} />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  )
}

export default withStyles(styles)(App)
